import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import {
  PlayTestMediumDescriptions,
  PlayTestMediumLabels,
  PlayTestMediumTypes,
} from "@seabrookstudios/pitch2table-core";
import CircularProgress from "@mui/material/CircularProgress";

const Label = "Play Test Location";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestMedium} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").PlayTestMedium) => void} props.onChange
 * @param {boolean} [props.isPending]
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 */
export const MediumSelect = ({ value, onChange, helperText, disabled = false, isPending = false }) => {
  /**
   * @param {*} ev
   */
  const onChangeHandler = (ev) => {
    onChange(ev.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal" disabled={disabled}>
      <InputLabel id="play-test-medium-label">{Label}</InputLabel>
      <Select
        labelId="play-test-medium-label"
        id="play-test-medium"
        value={value}
        onChange={onChangeHandler}
        placeholder={Label}
        label={Label}
        input={<OutlinedInput label={Label} />}
      >
        {isPending ? (
          <CircularProgress />
        ) : (
          PlayTestMediumTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {PlayTestMediumLabels[type]} - {PlayTestMediumDescriptions[type]}
            </MenuItem>
          ))
        )}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
